export enum EducationStatusEnum {
    AccomplishedDescription = 'Plan Accomplished',
    Accomplished = 1,
    InProgressDescription = 'Plan InProgress',
    InProgress = 2,
    DeclinedDescription = 'Plan Declined',
    Declined = 3,
}
